import { type Money } from '@egw/api'
import { buildBasicCurrency, Currency, getCurrencySymbol } from '@egw/utils'
import { type FC } from 'react'
import { Link } from 'react-router'

export interface CompanionHoldingProps {
  amount: Money
  symbol: string
  name: string
  href: string
}

export const CompanionHolding: FC<CompanionHoldingProps> = ({ amount, symbol, name, href }) => {
  return (
    <Link to={href} key={symbol} className="text-header font-normal">
      <div className="flex flex-row justify-between py-sm border-b border-gray-100" key={symbol}>
        <div className="typo-primary-base-semibold border-l-2 pl-xs border-action flex w-2/5 mr-md">{symbol}</div>
        <div className="flex typo-primary-base items-left w-2/5 justify-left">{name}</div>
        <div className="flex typo-primary-base w-1/5 self-end justify-end">{buildBasicCurrency(amount)}</div>
      </div>
    </Link>
  )
}
